module.exports = __webpack_public_path__ + "img/Vencasa-Payment-Icon-White.0d094113.webp";